import NavbarLayout from "components/layouts/NavbarLayout";
import PageHeading from "components/page/PageHeading";
import FundamenteiMetadata from "components/seo/FundamenteiMetadata";
import getYear from "date-fns/getYear";
import { Forum } from "components/forum/Forum";
import { IPostContextType } from "types/graphqlTypes";
import { MessageSquareMoreIcon } from "lucide-react";

export default function ForumIRPF() {
  const year = getYear(new Date());

  return (
    <NavbarLayout>
      <FundamenteiMetadata
        title="Fórum IRPF | Fundamentei"
        description={`Se você investe na Bolsa de Valores, é importante saber como declarar corretamente seus investimentos no Imposto de Renda (IRPF), tire suas dúvidas no nosso Fórum IRPF ${year}`}
      />

      <div className="flex w-full justify-center px-4 md:justify-start xl:mx-auto xl:max-w-7xl xl:px-0">
        <PageHeading
          title="Fórum IRPF"
          description={`Crie um tópico abaixo e tire a sua dúvida sobre o IRPF ${year} com o Asvid!`}
          icon={<MessageSquareMoreIcon className="h-6 w-6" />}
          iconContainerClassName="border-blue-200 bg-blue-50 text-blue-400"
        />
      </div>

      <div className="w-ful flex px-4 pb-4 xl:px-0 xl:pb-0">
        <Forum contextKey={null} contextType={IPostContextType.IrpfForum} />
      </div>
    </NavbarLayout>
  );
}
